import manifest from './manifest.json';

export function getManifest(): any
{
    // Find the highest resolution of each version of UI/Vehicle assets available
    const uiPng = manifest.default.image.ui.standard.high;
    const vehiclesPng = manifest.default.image.vehicles.standard.high;
    
    // Force app to always load highest version of UI/Vehicle, regardless the quality version set
    manifest.default.image.ui.standard.low = uiPng;
    manifest.default.image.ui.standard.default = uiPng;
    manifest.default.image.ui.standard.high = uiPng;
    manifest.default.image.vehicles.standard.low = vehiclesPng;
    manifest.default.image.vehicles.standard.default = vehiclesPng;
    manifest.default.image.vehicles.standard.high = vehiclesPng;
    
    if(manifest.default.image.ui.webp){
        const uiWebp = manifest.default.image.ui.webp.high;
        manifest.default.image.ui.webp.low = uiWebp;
        manifest.default.image.ui.webp.default = uiWebp;
        manifest.default.image.ui.webp.high = uiWebp;
    }
    if(manifest.default.image.vehicles.webp){
        const vehiclesWebp = manifest.default.image.vehicles.webp.high;
        manifest.default.image.vehicles.webp.low = vehiclesWebp;
        manifest.default.image.vehicles.webp.default = vehiclesWebp;
        manifest.default.image.vehicles.webp.high = vehiclesWebp;
    }
    
    return manifest;
}
